import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases, type Purchase } from '../data/purchases';
import { PRODUCT_NAME } from './constants';
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState<Purchase>(purchases[0]);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);
  if (!visible) return null;
  return <aside className="fixed bottom-3 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[260px] animate-slide-in" aria-live="polite" data-id="element-111" data-mp="165hcgvwws971">
      <div className="relative overflow-hidden rounded-xl border-2 border-brand-orange bg-white p-2.5 pr-7 shadow-2xl ring-2 ring-brand-gold/70" data-id="element-112" data-mp="116mges9xko4z">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-gold" data-id="element-113" data-mp="1awz7l3c93fk3" />
        <button type="button" onClick={() => setVisible(false)} className="absolute right-1.5 top-1.5 rounded p-0.5 text-brand-muted transition-colors duration-150 ease-out hover:text-brand-ink" aria-label="Fermer la notification" data-id="element-114" data-mp="1aysgkpac6bv9">
          <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-115" data-mp="x6m2d8qqueyg" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-116" data-mp="s5eul9olpfrs">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-brand-orange/60 bg-brand-gold/20" data-id="element-117" data-mp="28kg22f5979s0">
            <ShoppingBagIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-118" data-mp="23kbnwvrtir4y" />
          </span>
          <div className="min-w-0 leading-tight" data-id="element-119" data-mp="2anrvj5w77ahy">
            <p className="font-display text-[13px] font-extrabold text-brand-ink" data-id="element-120" data-mp="2fno139kjn9zm">{current.name}</p>
            <p className="text-[11px] font-semibold text-brand-muted" data-id="element-121" data-mp="2kmr5qswm3e72">
              de {current.city}, {current.region}
            </p>
            <p className="mt-0.5 text-[11px] font-bold text-brand-orange" data-id="element-122" data-mp="2pksotdu1fdij">
              vient d’acheter {PRODUCT_NAME}
            </p>
          </div>
        </div>
      </div>
    </aside>;
}